export const PROJECT_STATUS = {
  planificado: { label: 'Planificado', cls: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
  en_ejecucion: { label: 'En ejecución', cls: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300' },
  completado: { label: 'Completado', cls: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300' },
  cancelado: { label: 'Cancelado', cls: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' },
};

export const ACTIVITY_STATUS = {
  pendiente: { label: 'Pendiente', bar: 'bg-slate-400', dot: 'bg-slate-400' },
  en_progreso: { label: 'En progreso', bar: 'bg-sky-500', dot: 'bg-sky-500' },
  bloqueada: { label: 'Bloqueada', bar: 'bg-red-500', dot: 'bg-red-500' },
  completada: { label: 'Completada', bar: 'bg-emerald-500', dot: 'bg-emerald-500' },
};

export const VERDICT = {
  pendiente: { label: 'Pendiente de medir', cls: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
  vencida: { label: 'Vencida sin medición', cls: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
  cumplida: { label: 'Predicción cumplida', cls: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300' },
  parcial: { label: 'Cumplida parcialmente', cls: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
  no_cumplida: { label: 'No cumplida', cls: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' },
};

export const fmtDate = (d) => (d ? new Date(`${String(d).slice(0, 10)}T12:00:00`).toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const memberName = (members, id) => members.find((m) => m.id === id)?.full_name || 'Sin asignar';
export const SELECT_CLS = 'h-9 w-full rounded-md border border-slate-300 bg-transparent px-2 text-sm dark:border-slate-700 dark:bg-slate-900';
